import { intervalToDuration } from 'date-fns';
import { useEffect, useState } from 'react';
import { useNow } from './use-now';

export function useDurationSince({
    date,
    signal,
    interval,
}: {
    date: Date;
    signal?: unknown;
    interval?: number;
}): Duration {
    const now = useNow({ signal, interval });
    const [duration, setDuration] = useState(intervalToDuration({ start: date, end: now }));
    useEffect(() => {
        setDuration(intervalToDuration({ start: date, end: now }));
    }, [now, date]);
    return duration;
}
